import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_trans_log_tabs = _resolveComponent("trans-log-tabs");
  const _component_trans_log_tables = _resolveComponent("trans-log-tables");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_trans_log_tabs), _createElementVNode("div", null, [_createVNode(_component_trans_log_tables, {
    columns: _ctx.columns,
    actionType: _ctx.actionType
  }, null, 8, ["columns", "actionType"])])], 64);
}